"use client";

import { CheckCircle2, Circle } from "lucide-react";

export function JourneyChapterCompletionButton({
  completed,
  disabled = false,
  onToggle,
}: {
  completed: boolean;
  disabled?: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      disabled={disabled}
      aria-pressed={completed}
      className="inline-flex min-h-11 items-center justify-center gap-2 rounded-xl border border-white/10 bg-white/[0.04] px-4 py-3 text-sm font-bold text-zinc-200 transition-all hover:border-white/20 hover:bg-white/[0.08] disabled:cursor-not-allowed disabled:opacity-50"
    >
      {completed ? <CheckCircle2 size={14} /> : <Circle size={14} />}
      {completed ? "Mark incomplete" : "Mark complete"}
    </button>
  );
}
